import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { fetchInvoicePdf } from "@/lib/api/invoice";
import DownloadInvoiceButton from "@/components/invoice/DownloadInvoiceButton";
import InvoiceSkeleton from "@/app/components/common/skeletons/InvoiceSkeleton";

export default function InvoicePage() {
  const params = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const id = params.id ?? searchParams.get("id") ?? undefined;
  const [pdf, setPdf] = useState<{ data: string; filename: string } | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!id) {
      setNotFound(true);
      setIsLoading(false);
      return;
    }

    void fetchInvoicePdf(id)
      .then((result) => {
        setPdf(result);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  if (isLoading) {
    return <InvoiceSkeleton />;
  }

  if (notFound || !id) {
    return (
      <main className="mx-auto w-full max-w-7xl p-4 md:p-8">
        <h1 className="text-xl font-semibold">Invoice Preview</h1>
        <p className="mt-4 text-sm text-gray-600">Invoice not found.</p>
      </main>
    );
  }

  if (!pdf) {
    return (
      <main className="mx-auto w-full max-w-7xl p-4 md:p-8">
        <h1 className="text-xl font-semibold">Invoice Preview</h1>
        <p className="mt-4 text-sm text-gray-600">
          Invoice PDF is not available. Try again later or contact support if
          the issue persists.
        </p>
      </main>
    );
  }

  return (
    <main className="mx-auto w-full max-w-7xl p-4 md:p-8">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Invoice Preview</h1>
        <DownloadInvoiceButton id={id} />
      </div>

      <iframe
        title="Invoice Preview"
        src={`data:application/pdf;base64,${pdf.data}#toolbar=0`}
        className="h-[85vh] w-full rounded border bg-transparent"
      />
    </main>
  );
}
